import { render, staticRenderFns } from "./DiskHeader.vue?vue&type=template&id=1743c31b&scoped=true&"
import script from "./DiskHeader.vue?vue&type=script&lang=js&"
export * from "./DiskHeader.vue?vue&type=script&lang=js&"
import style0 from "./DiskHeader.vue?vue&type=style&index=0&id=1743c31b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1743c31b",
  null
  
)

export default component.exports